import React from 'react';
import styled from 'styled-components';
import { format } from 'date-fns-tz';
import DoughnutGauge from 'areas/dashboard/components/DoughnutGauge';

import { ASSESSMENT_PERIOD_CLOSED, ASSESSMENT_PERIOD_IN_PROGRESS, ASSESSMENT_PERIOD_OPEN, } from '../constants';
import StatusLabel from 'common/components/StatusLabel';

type AssessmentSummaryCardProps = {
  data: any;
  selectedAssessmentPeriod: any;
};

const AssessmentSummaryCard = ({
  data,
  selectedAssessmentPeriod,
}: AssessmentSummaryCardProps) => {


  const getAssessmentStatus = (selectedAssessmentPeriod: any) => {
    const now = Date.now();
    const closeAt = selectedAssessmentPeriod.end_date_time ? new Date(selectedAssessmentPeriod.end_date_time).getTime() : null;

    let color = '#9e9e9e';
    let label = 'Unknown';

    switch (selectedAssessmentPeriod.status) {
      case ASSESSMENT_PERIOD_OPEN:
        label = 'Scheduled';
        color = '#9A9A9A';
        break;
      case ASSESSMENT_PERIOD_IN_PROGRESS:
        label = 'In Progress';
        color = '#1976d2';
        break;
      case ASSESSMENT_PERIOD_CLOSED:
        label = 'Closed';
        color = '#2e7d32';
        break;
      default:
        break;
    }

    // Special case: schedule is live but end date passed
    if (selectedAssessmentPeriod.status === ASSESSMENT_PERIOD_IN_PROGRESS && closeAt && closeAt < now) {
      return <StatusLabel color="#ef6c00" title="Awaiting Closure">Awaiting Closure</StatusLabel>;
    }

    return <StatusLabel color={color} title={label}>{label}</StatusLabel>;
  };


  return (
    <ColumnContainer>
      {/* Column 1 */}
      <Column flex={1}>
        <DoughnutGauge
          title="Member Participation"
          complete={
            data?.total_requests > 0 ? (data?.total_responses / data?.total_requests) * 100 : 0
          }
          percent={true}
          size="medium"
        />
      </Column>

      {/* Column 2 */}
      <Column flex={2}>
        <InnerContainer>
          <Grid>
            <FormLabel>Status</FormLabel>
            {getAssessmentStatus(selectedAssessmentPeriod)}

            {selectedAssessmentPeriod?.start_date_time && (
              <>
                <FormLabel>Start</FormLabel>
                <Value>
                  {format(new Date(selectedAssessmentPeriod.start_date_time), 'MMM. d, yyyy')}{' '}
                  {format(new Date(selectedAssessmentPeriod.start_date_time), 'h:mm a')}
                </Value>
              </>
            )}

            {selectedAssessmentPeriod?.end_date_time && (
              <>
                <FormLabel>End</FormLabel>
                <Value>
                  {format(new Date(selectedAssessmentPeriod.end_date_time), 'MMM. d, yyyy')}{' '}
                  {format(new Date(selectedAssessmentPeriod.end_date_time), 'h:mm a')}
                </Value>
              </>
            )}

            <FormLabel>Requests</FormLabel>
            <Value>{data?.total_requests}</Value>

            <FormLabel>Responses</FormLabel>
            <Value>{data?.total_responses}</Value>
          </Grid>
        </InnerContainer>
      </Column>
    </ColumnContainer>
  );
};
export default AssessmentSummaryCard;

const ColumnContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const Column = styled.div<{ flex?: number }>`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  align-items: center;
  justify-content: ${props => (props.flex === 1 ? 'flex-start' : 'space-between')};
  flex: ${props => props.flex || 1};
  min-height:150px;
`;

const InnerContainer = styled.div`
  padding-left: 20px;
  padding-top: 10px;
  width: 100%;
`;
const Grid = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: 3px;
  width: 100%;
  align-items: center;  
  justify-items: start;   
`;

const FormLabel = styled.span`
  text-align: left;
  font-weight: 500;
`;

const Value = styled.span<{ color?: string }>`
  text-align: left;
  font-weight: ${props => (props.color ? 'bold' : 'normal')};
  color: ${props => props.color || 'inherit'};
`;

const SectionTitle = styled.span`
  text-align: left;
  padding-bottom: 3px;
  font-size: 14px;
  font-weight: 600;
`;

const SelectContainer = styled.div`
  text-align: left;
`;
